import { useNavigate } from 'react-router';
import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';
import { CasErrorDisplay, CasPage } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { useCurrentUserEmployee } from 'src/compass/application';

import TouchpointsTab from './_touchpoints/components/TouchpointsTab';
import UnassignedTab from './_touchpoints/components/UnassignedTab';

export const TabListEntityTouchpoints = {
  noDefault: false,
  tabs: [
    { label: 'Touchpoints', children: <TouchpointsTab /> },
    { label: 'Unassigned', children: <UnassignedTab /> },
  ],
};

export default function TouchpointsPage() {
  const navigate = useNavigate();

  const {
    data: currentUserData,
    isLoading: currentUserLoading,
    isError: isCurrentUserError,
    error: currentUserError,
  } = useCurrentUserEmployee();

  const { isFetching, isError, error } = useRetrieve({
    url: 'Utilities/EntityTouchpoint/HasUnassignedEntity',
    params: { employeeId: currentUserData?.employeeId },
    enabled: !!currentUserData?.employeeId,
    onSuccess: (response: any) => {
      if (response.hasUnassigned)
        navigate('/riskManagement/touchpoints/Unassigned', {
          state: { autoNavigated: true },
        });
      return response;
    },
  });

  if (currentUserLoading || isFetching) return <CasLoader />;
  if (isCurrentUserError || isError)
    return (
      <CasErrorDisplay
        message={currentUserError?.message || error?.message || 'An error occurred'}
      />
    );

  return (
    <CasPage title="Touchpoints" pageTitle="Risk Management">
      <CasRouterTabs
        tabList={TabListEntityTouchpoints.tabs}
        baseUrl="/riskmanagement/touchpoints"
      />
    </CasPage>
  );
}